(function () {
  'use strict';

  /* Mobile navigation */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* Counter animation */
  function animateCount(el) {
    var raw = el.getAttribute('data-count');
    var target = parseInt(raw, 10);
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.hasAttribute('data-count')) animateCount(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    document.querySelectorAll('.category-card, .feature, .value, .stat, .product-card, .contact-card').forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
    document.querySelectorAll('[data-count]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Product gallery thumbnails */
  var main = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) {
        main.src = btn.getAttribute('data-full');
        main.removeAttribute('srcset');
      }
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* Product variant selection */
  var jsonEl = document.querySelector('[data-product-json]');
  var form = document.querySelector('[data-product-form]');
  if (jsonEl && form) {
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = null; }
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('[data-price]');

    var formatMoney = function (cents) {
      var value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return value + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : '');
    };

    var update = function () {
      if (!product || !selects.length) return;
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = product.variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Mevcut Değil';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Sepete Ekle' : 'Stokta Yok';
      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + '?variant=' + variant.id);
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }
})();
